import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Sugestões de Aquisição',
    path: '/biblioteca/bibsugestaoaquisicao',
    name: 'bibsugestaoaquisicao',
    component: () => import('@/views/biblioteca/bibsugestaoaquisicao/Index.vue'),
    meta: {
      // Não existe item de menu próprio para sugestões de aquisição, então a tela
      // é liberada pela Catalogação: aprovar/adquirir uma sugestão desemboca no
      // cadastro da obra. Se vocês criarem um item dedicado, troque aqui.
      permissions: [eTipoPermissao.BIB_SUGESTOESDEAQUISICAONOVO_MENU_1300100198],
    },
    goesToMenu: true,
  },
];
